import * as React from 'react';
import styled from 'styled-components';
import {
  compose,
  space,
  color,
  layout,
  typography,
  SpaceProps,
  ColorProps,
  LayoutProps,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="M5.544 5.47a5.59 5.59 0 00-1.5 1.075c-.89.89-1.542 2.132-1.542 3.457v4a1 1 0 002 0v-4c0-.675.347-1.433.957-2.043.494-.494 1.086-.817 1.652-.922L5.544 5.47zm11.468 11.47a2.229 2.229 0 01-.51.062H8.31l.923-.984a1 1 0 00-1.46-1.368l-2.498 2.666a1.002 1.002 0 000 1.372l2.498 2.666a1 1 0 101.46-1.368l-.923-.984h8.193a4.53 4.53 0 002.054-.519l-1.544-1.544zm3.453-.062l-1.434-1.434c.305-.47.471-.977.471-1.444v-4a1 1 0 112 0v4c0 1.058-.416 2.063-1.037 2.878zM10.587 7l-2-2h7.11l-.925-.986a1 1 0 111.46-1.368l2.498 2.666a.996.996 0 01.273.686.998.998 0 01-.273.686L16.232 9.35a1 1 0 11-1.46-1.368L15.693 7h-5.106z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.793 3.293a1 1 0 011.414 0l16.5 16.5a1 1 0 01-1.414 1.414l-16.5-16.5a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
});
export const IconSystemV2MediaUnrepeat = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
